import { useEffect } from 'react'

/** Rows per page on the case lists (Cases queue, Allocations). */
export const CASE_PAGE_SIZE = 25

/** Pages needed for `total` rows; null while the total is unknown. */
export function pageCountFor(total: number | null, pageSize = CASE_PAGE_SIZE): number | null {
  return total === null ? null : Math.max(1, Math.ceil(total / pageSize))
}

/**
 * Cases close or get allocated while a list auto-refreshes; pull `page` back
 * to the last page when the total shrinks under it, so nobody is stranded on
 * a page that no longer exists.
 */
export function useClampPage(page: number, setPage: (p: number) => void, pageCount: number | null) {
  useEffect(() => {
    if (pageCount !== null && page > pageCount - 1) setPage(pageCount - 1)
  }, [page, pageCount, setPage])
}
